import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import CardPayment from '~/src/features/payments-abn/components/CardPayment';
import { CardPaymentForm } from '~/src/features/payments-abn/components/CardPayment/CardPaymentForm';
import PaymentFrame from '~/src/features/payments-abn/components/PaymentFrame';
import { PaymentMethodCards } from '~/src/features/payments-abn/components/PaymentMethodCards';
import { SberPay } from '~/src/features/payments-abn/components/SberPay';
import SbpPaymentDetail from '~/src/features/payments-abn/components/useSbpPayment/SbpPaymentDetail';
import { INewCardPayment, initPaymentState, newCardPayment } from '~/src/features/payments-abn/store/actions';
import { IQueryPaymentParams } from '~/src/features/payments-abn/types';
import { TState } from '~/src/store';

interface IProps {
    paymentSum?: number,
}

export const PaymentBlock = ({ paymentSum = 0 }: IProps): JSX.Element | null => {
    const dispatch = useDispatch();
    const { query: { pay: queryPay, agreement: queryAgreement, s: queryPaySum, deliveryRequestId = null } } = useRouter<IQueryPaymentParams>();

    const isOnlinePay = queryPay === 'online' && !!queryPaySum && !!queryAgreement;

    const {
        frameUrl,
    } = useSelector((state: TState) => ({
        frameUrl: state.payment.result.frameUrl,
    }), shallowEqual);


    useEffect(() => {
        dispatch(initPaymentState(paymentSum));
    }, []);

    useEffect(() => {
        if (isOnlinePay) {
            const newCardArgs: INewCardPayment = {
                _agreement: queryAgreement,
            };

            if (deliveryRequestId) {
                newCardArgs.deliveryRequestId = deliveryRequestId;
            }

            dispatch(newCardPayment(newCardArgs));
        }
    }, [isOnlinePay]);

    return (
        <>
            {frameUrl
                ? <PaymentFrame/> // TODO перенести PaymentFrame внутрь метода оплаты картой CardPayment, для оплаты новой картой
                : <>
                    <PaymentMethodCards />

                    <SbpPaymentDetail />

                    <SberPay />

                    <CardPayment>
                        <CardPaymentForm />
                    </CardPayment>
                </>
            }
        </>
    );
};
